editHandoverController.$inject = ['$scope', '$uibModalInstance', '$translate', 'QuickRepliesFactory', 'controllerParams'];
export function editHandoverController($scope, $uibModalInstance, $translate, QuickRepliesFactory, controllerParams) {
  $scope.submitHandover = submitHandover;
  $scope.cancel = cancel;

  init();

  function submitHandover(answ) {
    $uibModalInstance.close({type: 'edit', data: answ});
  }

  function cancel() {
    $uibModalInstance.dismiss('cancel');
  }

  function init() {
    $scope.handover = {
      'target_app_id': controllerParams.target_app_id,
      'thread_control_metadata': controllerParams.thread_control_metadata,
      'timeout': controllerParams.timeout
    };

    $scope.hasTargetAppId = controllerParams.hasTargetAppId;
  }

}
